import { render } from "./TutorsAdmin.vue?vue&type=template&id=18d1f4a0&scoped=true"
import script from "./TutorsAdmin.vue?vue&type=script&lang=js"
export * from "./TutorsAdmin.vue?vue&type=script&lang=js"

import "./TutorsAdmin.vue?vue&type=style&index=0&id=18d1f4a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d1f4a0"]])

export default __exports__